import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box
} from '@mui/material';
import { Icon } from '@iconify/react';

const CommonAccordion = ({
  title,
  children,
  defaultExpanded = false,
  expandIcon = <Icon icon="mdi:chevron-down" width={20} />,
  sx = {},
  titleSx = {fontSize: '1.25rem', fontWeight: 500, color: '#333'},
  ...rest
}) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      square={false}
      sx={{
        mb: 1,
        padding: '12px',
        '&:before': { display: 'none' },
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        },
        ...sx,
      }}
      {...rest}
    >
       <AccordionSummary
        expandIcon={expandIcon}
        sx={{
          borderRadius: '12px',
          '& .MuiAccordionSummary-content': {
            margin: 0,
          },
        }}
      >
        <Typography sx={titleSx}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box>{children}</Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default CommonAccordion;
